import{RP_AVERAGE_GAS_MODEL_LIST, RP_AVERAGE_GAS_PAGINATION, RP_AVERAGE_GAS_SEARCH,RP_AVERAGE_GAS_DROP_DOWN_SEARCH_YEAR}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: RP_AVERAGE_GAS_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: RP_AVERAGE_GAS_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: RP_AVERAGE_GAS_PAGINATION,
    payload
})

export const setDropDownSearchYear = (payload) => ({
    type: RP_AVERAGE_GAS_DROP_DOWN_SEARCH_YEAR,
    payload
})